export enum WifiDialogState {
  Join,
  Forget,
  Closed,
}
